import { string } from 'prop-types';
import { IntegrationEventType } from '../../../../../store/IntegrationEventTypes/models';

export const initialValues: IntegrationEventType = {
  eventType: '',
};
